import Vue from 'vue'
import api from '@/api'
import { defaultVideoBitRate } from '@/config'
import H264Decoder from '@/utils/h264DecoderWebGL'
// import storejs from 'store'
// import { PromiseAll } from '@/utils/utils'

const state = {
  tars: [],
  blindTarUrl: '',
  isContinuous: true,
}

const getters = {}

const mutations = {
  setCamera(state, { idx, cameraId }) {
    Vue.set(state.tars[idx], 'cameraId', cameraId)
  },
}

const actions = {
  getTarData({ state }, tarIdx) {
    return new Promise((resolve, reject) => {
      Vue.set(state.tars[tarIdx], 'loading', true)
      if (state.tars[tarIdx].cameraIds) {
        // 已经有 camera 信息
        // 查看摄像头是否合法
        const params = {
          tarUrl: state.tars[tarIdx].tarUrl,
          cameraId: state.tars[tarIdx].cameraId,
          bitrateInMbps: defaultVideoBitRate,
        }
        api
          .getCameraData(params)
          .then(({ data }) => {
            H264Decoder(
              data.videoUrl,
              () => {},
              info => {
                Vue.set(state.tars[tarIdx], 'frameCount', info.frame)
                state.tars[tarIdx].frameRange = [0, info.frame - 1]
                Vue.set(state.tars[tarIdx], 'loading', false)
                resolve()
                return false
              },
            )
          })
          .catch(new Error('Get camera info error: ' + JSON.stringify(params)))
      } else {
        // 没有 camera 信息
        api
          .getTarInfo({ tarId: state.tars[tarIdx].tarId })
          .then(({ data: tarInfo }) => {
            state.tars[tarIdx].tarUrl = tarInfo.OssPath
            api
              .getCameraList({ tarUrl: tarInfo.OssPath })
              .then(({ data: cameraInfo }) => {
                state.tars[tarIdx].cameraIds = cameraInfo.cameraIds
                if (state.tars[tarIdx].cameraId === undefined) {
                  state.tars[tarIdx].cameraId = cameraInfo.cameraIds[0]
                }
                const params = {
                  tarUrl: tarInfo.OssPath,
                  cameraId: state.tars[tarIdx].cameraId,
                  bitrateInMbps: defaultVideoBitRate,
                }
                api
                  .getCameraData(params)
                  .then(({ data }) => {
                    H264Decoder(
                      data.videoUrl,
                      () => {},
                      info => {
                        Vue.set(state.tars[tarIdx], 'frameCount', info.frame)
                        // state.tars[tarIdx].frameCount = info.frame
                        state.tars[tarIdx].frameRange = [0, info.frame - 1]
                        Vue.set(state.tars[tarIdx], 'loading', false)
                        resolve()
                        return false
                      },
                    )
                  })
                  .catch(
                    reject(
                      new Error(
                        'Get camera info error: ' + JSON.stringify(params),
                      ),
                    ),
                  )
              })
              .catch(
                reject(
                  new Error('Get camera id list error: ' + tarInfo.OssPath),
                ),
              )
          })
      }
    })
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
